import * as React from 'react';
import classNames from 'classnames';
import AccurityIcon from '../../../icon/components/AccurityIcon';
var IconCell = function (_a) {
    var value = _a.value, graphics = _a.graphics;
    var doesMatchValue = function (candidateValue, matchValue) { return typeof candidateValue === 'string'
        ? candidateValue.split(',').includes(matchValue) // Support matching any of multiple comma-separated string values
        : candidateValue === matchValue; };
    var icon = graphics === null || graphics === void 0 ? void 0 : graphics.find(function (graphic) { return doesMatchValue(graphic.value, value); });
    return icon ? (React.createElement(AccurityIcon, { iconName: icon.iconName, className: classNames('sm iconColumn', icon.className) })) : null;
};
export default IconCell;
//# sourceMappingURL=IconCell.js.map